export default function animateExpenses(SVGs, injectorOptions) {
  SVGInjector(SVGs, injectorOptions, function(totalSVGsInjected) {
    // Callback after all SVGs are injected
    // console.log('We injected ' + totalSVGsInjected + ' SVG(s)!');

    //-- Rules animation Expense
    const rulescirc1 = $('.rules-anim-e .rules--1 .rules__circl').get(0),
        rulesinner1 = $('.rules-anim-e .rules--1 .rules__inner').get(0),
        rulesicon1 = $('.rules-anim-e .rules--1 .rules__picto1').get(0),
        rulesstep1 = $('.rules-anim-e .rules--1 .rules__step').get(0),
        rulescopy1 = $('.rules-anim-e .rules--1 .rules__desc').get(0),
        rulescirc2 = $('.rules-anim-e .rules--2 .rules__circl').get(0),
        rulesinner2 = $('.rules-anim-e .rules--2 .rules__inner').get(0),
        rulesicon2 = $('.rules-anim-e .rules--2 .rules__picto2').get(0),
        rulesstep2 = $('.rules-anim-e .rules--2 .rules__step').get(0),
        rulescopy2 = $('.rules-anim-e .rules--2 .rules__desc').get(0),
        rulescirc3 = $('.rules-anim-e .rules--3 .rules__circl').get(0),
        rulesinner3 = $('.rules-anim-e .rules--3 .rules__inner').get(0),
        rulesicon3 = $('.rules-anim-e .rules--3 .rules__picto3').get(0),
        rulesstep3 = $('.rules-anim-e .rules--3 .rules__step').get(0),
        rulescopy3 = $('.rules-anim-e .rules--3 .rules__desc').get(0),
        rulesarrow1 = $('.rules-anim-e .rules__arrow--1').get(0),
        rulesarrow2 = $('.rules-anim-e .rules__arrow--2').get(0);

    const rulesAnimExpense = new TimelineMax({repeat: 0});

    rulesAnimExpense
      .set(rulescirc1, { opacity: 0, transform: 'scale(.5)' })
      .set(rulesinner1, { opacity: 0, transform: 'scale(.5)' })
      .set(rulesicon1, { opacity: 0, transform: 'scale(.7)' })
      .set(rulesstep1, { opacity: 0, transform: 'scale(1.3)' })
      .set(rulescopy1, { opacity: 0, transform: 'translateY(14px)' })
      .set(rulesarrow1, { opacity: 0, transform: 'translateX(-20px)' })
      .set(rulescirc2, { opacity: 0, transform: 'scale(.5)' })
      .set(rulesinner2, { opacity: 0, transform: 'scale(.5)' })
      .set(rulesicon2, { opacity: 0, transform: 'scale(.7)' })
      .set(rulesstep2, { opacity: 0, transform: 'scale(1.3)' })
      .set(rulescopy2, { opacity: 0, transform: 'translateY(14px)' })
      .set(rulesarrow2, { opacity: 0, transform: 'translateX(-20px)' })
      .set(rulescirc3, { opacity: 0, transform: 'scale(.5)' })
      .set(rulesinner3, { opacity: 0, transform: 'scale(.5)' })
      .set(rulesicon3, { opacity: 0, transform: 'scale(.7)' })
      .set(rulesstep3, { opacity: 0, transform: 'scale(1.3)' })
      .set(rulescopy3, { opacity: 0, transform: 'translateY(14px)' })

      .to(rulescirc1, .6, { opacity: 1, transform: 'scale(1)', ease: Power2.easeOut })
      .to(rulesinner1, .6, { opacity: 1, transform: 'scale(1)', ease: Power2.easeOut, delay: -.4 })
      .to(rulesicon1, .8, { opacity: 1, transform: 'scale(1)', ease: Power2.easeOut, delay: -.3 })
      .to(rulesstep1, .4, { opacity: 1, transform: 'scale(1)', ease: Power2.easeOut, delay: -.2 })
      .to(rulescopy1, .8, { opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut })
      .to(rulesarrow1, .55, { opacity: 1, transform: 'translateX(0)', ease: Power2.easeOut, delay: .2 })

      .to(rulescirc2, .6, { opacity: 1, transform: 'scale(1)', ease: Power2.easeOut })
      .to(rulesinner2, .6, { opacity: 1, transform: 'scale(1)', ease: Power2.easeOut, delay: -.4 })
      .to(rulesicon2, .8, { opacity: 1, transform: 'scale(1)', ease: Power2.easeOut, delay: -.3 })
      .to(rulesstep2, .4, { opacity: 1, transform: 'scale(1)', ease: Power2.easeOut, delay: -.2 })
      .to(rulescopy2, .8, { opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut })
      .to(rulesarrow2, .55, { opacity: 1, transform: 'translateX(0)', ease: Power2.easeOut, delay: .2 })

      .to(rulescirc3, .6, { opacity: 1, transform: 'scale(1)', ease: Power2.easeOut })
      .to(rulesinner3, .6, { opacity: 1, transform: 'scale(1)', ease: Power2.easeOut, delay: -.4 })
      .to(rulesicon3, .8, { opacity: 1, transform: 'scale(1)', ease: Power2.easeOut, delay: -.3 })
      .to(rulesstep3, .4, { opacity: 1, transform: 'scale(1)', ease: Power2.easeOut, delay: -.2 })
      .to(rulescopy3, .8, { opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut })

    rulesAnimExpense.play();
    rulesAnimExpense.eventCallback('onComplete', startRoundAnimExpenses);

    //-- Repeat animation once it's done
    function startRoundAnimExpenses() {
      $('.rules-anim-e .rules__lineover').addClass('active');
      setTimeout(function () {
        $('.rules-anim-e .rules__lineover').removeClass('active');
        rulesAnimExpense.pause(0).play();
      }, 7000)
    }

    //-- Swipe animation
    const card = $('#cardswipe #card').get(0),
        hotel = $('#cardswipe #hotel').get(0),
        hotelbuilding = $('#cardswipe #hotelbuilding').get(0),
        airticket = $('#cardswipe #airticket').get(0),
        airplane = $('#cardswipe #airplane').get(0),
        uber = $('#cardswipe #uber').get(0),
        ubercar = $('#cardswipe #car').get(0),
        start = $('#cardswipe #start').get(0),
        end = $('#cardswipe #end').get(0),
        ride = $('#cardswipe #ride').get(0),
        receipt1 = $('#cardswipe #receipt1').get(0),
        receipt2 = $('#cardswipe #receipt2').get(0),
        receipt3 = $('#cardswipe #receipt3').get(0);

    const swipeAnim = new TimelineMax({repeat: -1});

    swipeAnim
      .set(hotel, { opacity: 0, transform: 'translateX(-22px)', transformOrigin: 'center center' })
      .set(hotelbuilding, { opacity: 0, transform: 'translateX(-25px)' })
      .set(airticket, { opacity: 0, transform: 'translateX(-22px)', transformOrigin: 'center center' })
      .set(airplane, { opacity: 0, transform: 'translateX(-80px)' })
      .set(uber, { opacity: 0, transform: 'translateX(-22px)', transformOrigin: 'center center' })
      .set(ubercar, { opacity: 0 })
      .set(start, { opacity: 0, transformOrigin: 'center center' })
      .set(end, { opacity: 0, transformOrigin: 'center center' })
      .set(ride, { opacity: 0 })
      .set(receipt1, { opacity: 0, transform: 'translateX(-22px)' })
      .set(receipt2, { opacity: 0, transform: 'translateX(-22px)' })
      .set(receipt3, { opacity: 0, transform: 'translateX(-22px)' })

      .to(card, .6, { transform: 'translateX(60px)', ease: Power2.easeOut })
      .to(card, .6, { transform: 'translateX(0)', ease: Power2.easeOut })
      .to(hotel, 1, { opacity: 1, transform: 'translateX(0)', ease: Power2.easeOut, delay: -.2 })
      .to(hotelbuilding, 1.2, { opacity: 1, transform: 'translateX(0)', ease: Power2.easeOut, delay: -.5 })
      .to(receipt1, .8, { opacity: 1, transform: 'translateX(0)', ease: Power2.easeOut, delay: -.3 })
      .to(hotel, .75, { opacity: 0, transform: 'translateX(32px)', ease: Power2.easeOut, delay: .5 })

      .to(card, .6, { transform: 'translateX(60px)', ease: Power2.easeOut, delay: -.4 })
      .to(card, .6, { transform: 'translateX(0)', ease: Power2.easeOut })
      .to(airticket, 1, { opacity: 1, transform: 'translateX(0)', ease: Power2.easeOut, delay: -.2 })
      .to(airplane, 1.2, { opacity: 1, transform: 'translateX(0)', ease: Power2.easeOut, delay: -.35 })
      .to(receipt2, .8, { opacity: 1, transform: 'translateX(0)', ease: Power2.easeOut, delay: -.3 })
      .to(airticket, .75, { opacity: 0, transform: 'translateX(32px)', ease: Power2.easeOut, delay: .5 })

      .to(card, .6, { transform: 'translateX(60px)', ease: Power2.easeOut, delay: -.6 })
      .to(card, .6, { transform: 'translateX(0)', ease: Power2.easeOut })
      .to(uber, 1, { opacity: 1, transform: 'translateX(0)', ease: Power2.easeOut, delay: -.6 })
      .to(start, 1, { opacity: 1, ease: Power2.easeOut, delay: -.2 })
      .to(ride, 1, { opacity: 1, ease: Power2.easeOut, delay: -.5 })
      .to(end, 1, { opacity: 1, ease: Power2.easeOut, delay: -.5 })
      .to(ubercar, 1.4, { opacity: 1, transform: 'translateX(-60px)', ease: Power2.easeOut, delay: -.35 })
      .to(receipt3, .8, { opacity: 1, transform: 'translateX(0)', ease: Power2.easeOut, delay: -.6 })
      .to(uber, .75, { opacity: 0, transform: 'translateX(32px)', ease: Power2.easeOut, delay: .5 })

      .to(receipt3, .35, { opacity: 0, transform: 'translateX(22px)', ease: Power2.easeOut, delay: -.5 })
      .to(receipt2, .35, { opacity: 0, transform: 'translateX(22px)', ease: Power2.easeOut, delay: -.25 })
      .to(receipt1, .35, { opacity: 0, transform: 'translateX(22px)', ease: Power2.easeOut, delay: -.25 })

    // swipeAnim.play();

  });
}
